import { createUppyPlugin } from '@ohmybible/core';

export const UppyPlugin = createUppyPlugin({
  endpoint: import.meta.env.VITE_OMB_API_URL,
  cookiesRule: 'include',
});
